module.exports = __webpack_public_path__ + "static/img/default_friend.0b41b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/defaultTip/img/default_friend.jpg
// module id = 5VSz
// module chunks = 27